export default __webpack_public_path__ + "static/media/logo.4eedffc3.png";